module.exports = __webpack_public_path__ + "img/ch.e33162e8.svg";